import { FC, useState } from 'react'
import { Switch } from '@headlessui/react'
import { callbackIfExists, classNames } from 'functions'

interface ToggleWithDescProps {
  label: string
  defaultValue?: boolean
  description?: string
  callback: (on: boolean) => any
}

const ToggleWithDesc: FC<ToggleWithDescProps> = ({ label, description, callback, defaultValue = true }) => {
  const [enabled, setEnabled] = useState(defaultValue)

  return (
    <Switch.Group as="div" className="flex items-center justify-between">
      <span className="flex-grow flex flex-col">
        <Switch.Label as="span" className="text-sm font-medium" passive>
          {label}
        </Switch.Label>
        {description && <Switch.Description as="span" className="text-sm weak-text" style={{whiteSpace: 'pre-line'}}>
          {description}
        </Switch.Description>}
      </span>
      <Switch
        checked={enabled}
        onChange={(state) => {
          setEnabled(state)
          callbackIfExists(callback(state))
        }}
        className={classNames(
          enabled ? 'bg-primary' : 'bg-inactive',
          'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-max cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 rounded-max bg-white shadow transform ring-0 transition ease-in-out duration-200'
          )}
        />
      </Switch>
    </Switch.Group>
  )
}

export default ToggleWithDesc;